export default "__VITE_ASSET__CtUC7RS8__"